module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-container-single element-non-bodymatter element-type-titlepage title-page automatic-title-page",
    attrs: {
      "epub:type": "titlepage",
      "id": "title-page"
    }
  }, [_c('div', {
    staticClass: "title-page-title-subtitle-block"
  }, [_c('h1', {
    staticClass: "title-page-title"
  }, [_vm._v("Brother Blood Sister Death")])]), _vm._v(" "), _c('div', {
    staticClass: "title-page-contributor-block"
  }, [_c('div', {
    staticClass: "title-page-contributor-primary-block"
  }, [_c('h2', {
    staticClass: "title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"
  }, [_c('span', {
    staticClass: "title-page-contributor-name"
  }, [_vm._v("Bill Ransom")])])])]), _vm._v(" "), _c('div', {
    staticClass: "publisher-block"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-block title-page-publisher-logo-aspect-square"
  }, [_c('div', {
    staticClass: "title-page-publisher-logo-size-container",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('img', {
    staticClass: "title-page-publisher-logo-image",
    attrs: {
      "alt": "WordFire Press",
      "src": "images/original.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6536f60e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/title-page.vue
// module id = 66
// module chunks = 0